export const APP_CONSTANTS = {
  site_name: "Secondconsult LLP",
};
